import { uuid } from "uuidv4"
import { trackEvent } from "./serverSide";
import { addCinemaFieldsToEventData, dataLayerPush } from "../analytics";
import { CinemaType, LoyaltyLevelType } from "../../types/entities";

export const trackUserSignUpBegin = () => {
    trackEvent(
        'ViewContent',
        uuid(),
        {
            content_ids: ['signup'],
            content_type: 'product',
            content_name: 'Sign Up',
            currency: 'MXN',
            value: 0,
            content_category: 'Sign Up'
        }
    );

    dataLayerPush({
        event: 'qualify_lead',
        currency: 'MXN',
        value: 0,
        method: 'cineusuario'
    });
};

export const trackUserSignUpEmailVerified = () => {
    trackEvent(
        'Lead',
        uuid(),
        {}
    );

    dataLayerPush({
        event: 'generate_lead',
        currency: 'MXN',
        value: 0,
        method: 'cineusuario'
    });
};

export const trackUserSignUpLevelSelect = (cinema: CinemaType | null, level: LoyaltyLevelType | null) => {
    const metaEventData = {};
    
    addLevelFieldsToMetaEventData(metaEventData, level);
    cinema && addCinemaFieldsToEventData(metaEventData, cinema);

    trackEvent(
        'AddToCart',
        uuid(),
        metaEventData
    );

    if (level) {
        const googleEventData = { event: 'add_to_cart' };
        addLevelFieldsToGoogleEventData(googleEventData, level);
        dataLayerPush(googleEventData);
    }
};

export const trackUserSignUpComplete = (cinema: CinemaType | null, level: LoyaltyLevelType | null, result: { transaction_id: string } | null) => {
    const eventData = {};

    addLevelFieldsToMetaEventData(eventData, level);
    cinema && addCinemaFieldsToEventData(eventData, cinema);

    trackEvent(
        'CompleteRegistration',
        uuid(),
        {}
    );
    trackEvent(
        'Purchase',
        uuid(),
        eventData
    );

    dataLayerPush({
        event: 'sign_up',
        method: level ? 'loop' : 'cineusuario'
    });
    
    if (level) {
        const googleEventData = {
            event: 'purchase',
            transaction_id: result ? `loop_${result.transaction_id}` : null
        };
        addLevelFieldsToGoogleEventData(googleEventData, level);
        dataLayerPush(googleEventData);
    }
};

function addLevelFieldsToMetaEventData(eventData: { [key: string]: any }, level: LoyaltyLevelType | null) {
    eventData.content_ids = [`loop_${level ? level.id : 'account_link'}`];
    eventData.content_type = 'product';
    eventData.content_name = `Sign Up - ${level ? level.name : 'Account Link'}`;
    eventData.currency = 'MXN';
    eventData.value = level ? level.price : 0;
    eventData.content_category = 'Loyalty Program > Sign up';
}

function addLevelFieldsToGoogleEventData(eventData: { [key: string]: any }, level: LoyaltyLevelType) {
    eventData.currency = 'MXN';
    eventData.value = level.price;
    eventData.items = [
        {
            item_id: `loop_${level.id}`,
            item_name: level.name,
            quantity: 1,
            price: level.price
        }
    ]
}